<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请选择">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in list" :key="index"></el-option>
  </el-select>
</template>

<script>
    export default {
        name: "EchelonUseType",
        watch: {
            value: {
                immediate: true,
                handler: function (value) {
                    this.data = value;
                }

            }
        },
        props:["value"],
        data() {
            return {data: "", list: [
                    {name: "储能领域", value: "1"},
                    {name: "基站备电", value: "2"},
                    {name: "低速动力", value: "3"},
                    {name: "其他", value: "4"}]}
        },methods:{
            handleChange(value){
                this.data=value;
                this.$emit("input",value)
            }
        }
    }
</script>

<style scoped>

</style>
